import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const themeSwitcherContainer = style({
  position: "relative",
  display: "flex",
  alignItems: "center",
  width: "100%",
  flexGrow: 1
});

export const themeSwitcherRoot = style({
  width: "100%",
  flexGrow: 1,
  height: primitiveTokens.sizing["10x"],
  padding: primitiveTokens.sizing["1x"],
  display: "flex",
  gap: primitiveTokens.sizing["1x"],
  borderRadius: primitiveTokens.sizing["3x"],
  border: "none",
  outline: "none",
  cursor: "pointer",
  backgroundColor: semanticThemeTokens.themeSwitcher.backgroundColor,
  color: semanticThemeTokens.themeSwitcher.textColor
});

export const themeSwitcherThumb = style({
  width: "50%",
  height: "100%",
  backgroundColor: semanticThemeTokens.themeSwitcher.thumbColor,
  borderRadius: primitiveTokens.sizing["2x"],
  transition: "transform 200ms",
  willChange: "transform",
  selectors: {
    "&[data-state='checked']": {
      transform: "translateX(100%)"
    }
  }
});

export const valueContainer = style({
  padding: primitiveTokens.sizing["1x"],
  width: "100%",
  position: "absolute",
  display: "flex",
  zIndex: 1,
  pointerEvents: "none"
});

export const valueElement = style({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: primitiveTokens.sizing["2x"],
  color: semanticThemeTokens.themeSwitcher.iconColor
});

export const valueText = style({
  color: semanticThemeTokens.themeSwitcher.textColor
});
